import { Injectable } from '@angular/core';
import {HttpObservable, HttpWrapper} from "../../http-helpers/http.wrapper";

@Injectable({
  providedIn: 'root'
})
export class AccessibilityStatementProxy {
  constructor(private httpWrapper: HttpWrapper) {
  }

  public getAccessibilityStatement(languageKey: number): HttpObservable<string> {
    return this.httpWrapper.getAnon('PatientPortalAccessibility', 'GetAccessibilityStatement', [{pName: "languageKey", pVal: languageKey}]);
  }
}
